import RoutePath from "routes/utils";

const baseBase = '/virtual-terminal';

export default {
  index: new RoutePath(`${baseBase}/`),
}
